import { Button, Collapse, Divider, IconButton, Paper, Typography, withStyles, withTheme } from "@material-ui/core"
import { Edit } from "@material-ui/icons"
import React, { Component } from "react"
import { connect } from "react-redux"
import { approveFindingAction, assignFindingAction, dismissFindingAction, selectFindingAction, solveFindingAction } from "../../Actions/FindingActions"
import MutableInfoCard from "../../Shared/Cards/MutableInfoCard"
import ImageContainer from "../../Shared/ImageContainer"
import autobind from "../../Utils/autobind"
import FindingAction from "./FindingAction"
import NoCheck from "./NoCheck"

const style = (theme) => ({
    container: {
        margin: 12,
    },
    statusTag: {
        padding: "6px 12px",
        borderRadius: 24,
        width: 120,
        textAlign: 'center',
        color: 'white'
    },
    statusTagContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: 24
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
        '& > *': {
            marginLeft: 12
        },
        marginTop: 24
    },
    evidence: {
        marginTop: 24,
        maxWidth: 400,
        width: 400,
        padding: 12,
        position: 'relative',
        height: 114
    },
    evidenceTitle: {
        textAlign: 'center'
    },
    evidenceImage: {
        position: 'absolute',
        top: "60%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    },
    evidences: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        '& > *': {
            margin: "24px 24px 0 24px",
            "@media (max-width:500px)": {
                margin: "24px 0 0 0"
            },
        }
    },
    titleContainer: {
        padding: 12,
        background: theme.palette.primary.main,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 24
    },
    title: {
        color: "white"
    },
    titleButton: {
        color: "white"
    },
    infoContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 12,
        flexWrap: 'wrap'
    },
    info: {
        width: 300,
        margin: 12,
        textAlign: 'center',
        "@media (max-width:500px)": {
            width: "100%",
            maxWidth: 'unset'
        },
    }
})

function getColor(status, theme) {
    switch (status) {
        case "Pendiente": return theme.palette.red.main
        case "Procesando": return theme.palette.blue.main
        case "Vencido": return theme.palette.red.main
        case "Terminado": return theme.palette.green.main
        case "Aprobado": return theme.palette.green.main
        case "Desestimado": return theme.palette.red.main
        default: return theme.palette.red.main
    }
}

const criticalityFormat = (level) => {
    switch (level) {
        case 0: { return "No Asignado" }
        case 1: { return 'No Critico' }
        case 2: { return "Poco Critico" }
        case 3: { return "Medianamente Critico" }
        case 4: { return "Altamente Critico" }
        default: { return "No Asignado" }
    }
}

function getImage(path) {
    if (path.includes("data:image")) {
        return path
    } else {
        return `${process.env.REACT_APP_IMG_URL}${process.env.REACT_APP_FINDING_IMG_FOLDER}${path}`
    }
}

const showInfo = [
    { name: "user_creator", label: "Usuario quien detectó" },
    { name: "activity", label: "Actividad" },
    { name: "preventive_measure", label: "Medida Preventiva" },
    { name: "criticality", label: "Criticidad", format: criticalityFormat },
    { name: "date_detected", label: "Fecha de detección" }
]

class Finding extends Component {
    constructor() {
        super()
        this.state = {
            openCollapse: false
        }
        autobind(Finding, this)
    }

    componentDidMount() {
        const { selectFinding, match } = this.props
        const id = match.params.id
        selectFinding(id)
    }

    handleApprove() {
        const { approveFinding, findings, online } = this.props
        const selected = findings.selected
        const body = {
            id: selected.id,
            status: 1,
            online: online.status
        }
        approveFinding(body)
    }

    handleDismiss() {
        const { dismissFinding, findings, online } = this.props
        const selected = findings.selected
        const body = {
            id: selected.id,
            status: 4,
            online: online.status
        }
        dismissFinding(body)
    }

    handleOpenCollapse() {
        this.setState({ openCollapse: !this.state.openCollapse })
    }

    render() {
        const { classes, findings, assignFinding, solveFinding, theme } = this.props
        const selected = findings.selected
        const { openCollapse } = this.state
        return (
            <div className={classes.container}>
                <div className={classes.statusTagContainer}>
                    <Typography
                        className={classes.statusTag}
                        style={{ background: getColor(selected.status, theme) }}
                        variant="body1"
                    >
                        {selected.status}
                    </Typography>
                </div>
                <MutableInfoCard
                    title="Información Hallazgo"
                    disableEdit
                    showInfo={showInfo}
                    formInfo={showInfo}
                    response={selected}

                />
                <div className={classes.evidences}>
                    <Paper className={classes.evidence}>
                        <Typography className={classes.evidenceTitle} variant="subtitle1">Evidencia</Typography>
                        <div className={classes.evidenceImage}>
                            <ImageContainer src={selected.evidence ? `${process.env.REACT_APP_IMG_URL}${process.env.REACT_APP_IMG_FOLDER}${selected.evidence}` : "/noimage.png"} alt="foto" height="64px" width="64px" />
                        </div>
                    </Paper>
                    <Paper className={classes.evidence}>
                        <Typography className={classes.evidenceTitle} variant="subtitle1">Evidencia de solución</Typography>
                        <div className={classes.evidenceImage}>
                            <ImageContainer src={selected.solution_evidence ? getImage(selected.solution_evidence) : "/noimage.png"} alt="foto" height="64px" width="64px" />
                        </div>
                    </Paper>
                </div>
                <Paper >
                    <div className={classes.titleContainer}>
                        <Typography variant="h2" className={classes.title}>
                            Información Avanzada
                        </Typography>
                        <IconButton onClick={this.handleOpenCollapse} className={classes.titleButton} size="small">
                            <Edit />
                        </IconButton>
                    </div>
                    <div className={classes.infoContainer}>
                        <div className={classes.info}>
                            <Typography variant="body2">Responsable</Typography>
                            <Typography variant="subtitle1">{selected.user}</Typography>
                        </div>
                        <div className={classes.info}>
                            <Typography variant="body2">Acción Inmediata</Typography>
                            <Typography variant="subtitle1">{selected.inmediate_action}</Typography>
                        </div>
                        <div className={classes.info}>
                            <Typography variant="body2">Fecha Límite</Typography>
                            <Typography variant="subtitle1">{selected.date_limit}</Typography>
                        </div>
                    </div>
                    <Divider />
                    <div className={classes.infoContainer}>
                        <div className={classes.info}>
                            <Typography variant="body2">Comentario de Resolución</Typography>
                            <Typography variant="subtitle1">{selected.solution_comment || "No hay comentario..."}</Typography>
                        </div>
                    </div>
                </Paper>
                <Collapse in={openCollapse} >
                    <NoCheck assignFinding={assignFinding} finding={selected} />
                    <FindingAction solveFinding={solveFinding} finding={selected} />
                </Collapse>
                <div className={classes.buttons}>
                    {selected.status !== "Desestimado" &&
                        <Button color="primary" variant="outlined" onClick={this.handleDismiss}>
                            Desestimar
                        </Button>
                    }
                    {selected.status !== "Aprobado" &&
                        <Button color="primary" variant="contained" onClick={this.handleApprove} disabled={
                            selected.status === "Procesando" ||
                            selected.status === "Pendiente" ||
                            selected.status === "Vencido"
                        }>
                            Aprobar
                        </Button>
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    findings: state.findings,
    online: state.online
})

const mapDispatchToProps = dispatch => ({
    selectFinding: (id) => dispatch(selectFindingAction(id)),
    assignFinding: (body) => dispatch(assignFindingAction(body)),
    solveFinding: (body) => dispatch(solveFindingAction(body)),
    dismissFinding: (body) => dispatch(dismissFindingAction(body)),
    approveFinding: (body) => dispatch(approveFindingAction(body))
})

export default withTheme(connect(mapStateToProps, mapDispatchToProps)(withStyles(style)(Finding)))
